var _defs, _metadata;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 573.815,
    height: 365.22089,
    id: "svg3014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3016"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata3019"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-124.70319,-262.17063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path296",
    style: {
      fontSize: "50.79999924px",
      lineHeight: "133.00000429%",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none"
    },
    d: "m 540.65423,262.20945 c -40.80802,0 -81.61604,0 -122.42402,0 -37.30032,93.10691 -74.60343,186.2127 -111.90485,279.31915 -37.30369,-93.10646 -74.60915,-186.21222 -111.91174,-279.31915 -23.2368,0 -46.47363,0 -69.71043,0 0,121.72737 0,243.45472 0,365.18207 19.30826,0 38.61652,0 57.92478,0 -0.0581,-50.23391 0.19241,-100.47132 -0.22287,-150.70282 -1.14144,-36.51446 -2.28285,-73.02892 -3.42429,-109.54338 35.19174,86.74838 70.37643,173.49962 105.57256,260.2462 14.43851,0 28.87703,0 43.31554,0 34.1236,-84.19289 68.26042,-168.38048 102.38913,-252.57134 0,84.19045 0,168.38089 0,252.57134 19.39128,0 38.78259,0 58.1739,0 0,-47.7239 0,-95.44781 0,-143.17173 24.71319,0 49.42634,0 74.13952,0 25.60645,47.72364 51.2089,95.44942 76.8178,143.17173 19.70965,0 39.41929,0 59.12894,0 -0.28737,-4.8025 0.92388,-10.33222 -2.4761,-14.33796 -26.12314,-47.20991 -52.24628,-94.41987 -78.36945,-141.62982 27.19403,-11.49197 50.33902,-33.96793 59.71968,-62.29042 7.037,-21.27483 6.92883,-44.46696 2.17814,-66.21221 -4.50394,-20.02848 -14.99719,-38.95952 -30.93757,-52.10684 -20.43145,-17.22367 -47.05182,-25.29464 -73.31999,-27.55546 -11.51582,-1.08628 -23.10009,-1.16297 -34.65871,-1.04936 z m 13.4881,49.66167 c 14.76605,0.15498 29.5752,2.19589 42.81034,9.27349 12.44398,6.6587 21.77847,18.64142 25.20772,32.33215 3.23497,12.30206 3.42868,25.46557 0.53766,37.85088 -3.996,15.8222 -15.73774,29.10074 -30.46422,35.88884 -13.35348,6.60025 -28.50353,7.73921 -43.16981,7.6323 -20.21028,-0.13985 -40.42116,-0.005 -60.63204,-0.0484 0,-40.97641 0,-81.95282 0,-122.92922 21.90345,0 43.8069,0 65.71035,0 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.dd698ee2004729d4127d38f80e2016d8.svg";
export { ForwardRef as ReactComponent };